import { useQuery } from "@tanstack/react-query";
import { BookingExtraResponse, BookingExtraResponseSchema } from "../response/IndexBookingExtraResponse";
import { privateApi } from "../../../api/api";

const API_VERSION = "v4";

interface UseIndexBookingExtraFilters {
    booking_room_id?: string;
}

interface UseIndexBookingExtraProps {
    page?: number;
    limit?: number;
    search?: string;
    booking_room_id?: string;
    filters?: UseIndexBookingExtraFilters;
}

const fetchBookingExtras = async ({ page = 1, limit = 10, search = '', booking_room_id, filters }: UseIndexBookingExtraProps): Promise<BookingExtraResponse> => {
    const params: Record<string, any> = {
        page,
        limit,
    };
    if (search) {
        params.search = search;
    }
    // Support both direct booking_room_id and filters.booking_room_id
    const bookingRoomId = booking_room_id || filters?.booking_room_id;
    if (bookingRoomId) {
        params['filter[booking_room_id]'] = bookingRoomId;
    }

    const response = await privateApi.get(`/${API_VERSION}/booking-extra`, { params });
    return BookingExtraResponseSchema.parse(response.data);
}

const useIndexBookingExtra = ({ page = 1, limit = 10, search = '', booking_room_id, filters }: UseIndexBookingExtraProps) => {
    const bookingRoomId = booking_room_id || filters?.booking_room_id;
    return useQuery({
        queryKey: ['booking-extras', page, limit, search, bookingRoomId],
        queryFn: () => fetchBookingExtras({ page, limit, search, booking_room_id, filters }),
        staleTime: 1000 * 60 * 5,
    });
}

export default useIndexBookingExtra;

